<template>
  <div class="nav">
    <ul class="">
      <li class="live_router"><router-link class="live_router" to="/live" data-title="Canlı Bahis"><span>Canlı Bahis</span></router-link></li>
      <li class="sportsbook_router"><router-link class="sportsbook_router" to="/sportsbook" data-title="Spor Bahisleri"><span>Spor Bahisleri</span></router-link></li>
      <li class="slot_router"><router-link class="slot_router" to="/slot" data-title="Slot"><span>Slot</span></router-link></li>
      <li class="casino_router"><router-link class="casino_router" to="/casino" data-title="Canlı Casino"><span>Canlı Casino</span></router-link></li>
      <li class="virtual_router"><router-link class="virtual_router" to="/virtual" data-title="Sanal"><span>Sanal</span></router-link></li>
      <li class="bingo_router"><router-link class="bingo_router" to="/bingo" data-title="Tombala"><span>Tombala</span></router-link></li>
      <li class="high_flyer_router"><router-link class="high_flyer_router" lang="en" to="/highflyer" data-title="High Flyer"><div class="label-menu hot">Yeni</div><span>High Flyer</span></router-link></li>
      <li class="other-g" v-if="!isMobile">
        <a href="javascript:;" class="other_router zeppelin_router">
          Diğer Oyunlar
          <ul>
            <li class="beton_router"><router-link class="beton_router" to="/beton" data-title="Betongames"><span>Betongames</span></router-link></li>
            <li class="binary_router"><router-link class="binary_router" to="/binary" data-title="Zeplin"><span>Binary</span></router-link></li>
            <li class="zeppelin_router"><router-link class="zeppelin_router" to="/zeppelin" data-title="Zeplin"><span>Zeplin</span></router-link></li>
            <li class="aviator_router"><router-link class="aviator_router" to="/aviator" data-title="Aviator"><span>Aviator</span></router-link></li>
            <li class="aviator_router"><router-link target="_blank" class="aviator_router" to="/slot/pragmaticplay/all?game_id=74201&mobile=false" data-title="Aviator"><span>Spaceman</span></router-link></li>
            <li class="aviator_router"><router-link target="_blank" class="aviator_router" to="/slot/smartsoft/all?game_id=75340&mobile=false" data-title="Aviator"><span>JetX</span></router-link></li>
          </ul>
        </a>
      </li>
      
      <slot v-if="isMobile">
            <li class="binary_router"><router-link class="binary_router" to="/binary" data-title="Zeplin"><span>Binary</span></router-link></li>
            <li class="zeppelin_router"><router-link class="zeppelin_router" to="/zeppelin" data-title="Zeplin"><span>Zeplin</span></router-link></li>
            <li class="aviator_router"><router-link class="aviator_router" to="/aviator" data-title="Aviator"><span>Aviator</span></router-link></li>
      </slot>
      <li class="discount_router" v-if="!isMobile && configSpesific.discountRequestSite"><a :href="url" class="discount_router" target="_blank" data-title="DISCOUNT TALEP">
        <svg viewBox="0 0 15 17" version="1.1"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="01.-Landing-Page" transform="translate(-1286.000000, -91.000000)" fill-rule="nonzero"><g id="promotions-button" transform="translate(1271.705534, 82.000000)"><path d="M26.5346088,9.31207346 C26.6181176,9.38479182 26.6850889,9.46525117 26.7359184,9.55107643 L26.781382,9.63860236 L27.2386476,10.6651041 C27.4368725,11.1096505 27.4445642,11.5902771 27.2680932,12.0254876 L27.1932964,12.1864035 L23.4404034,12.1864035 C23.5004546,12.0103156 23.533608,11.8217171 23.533608,11.6256121 C23.533608,11.460471 23.5102091,11.3007838 23.466842,11.1494534 L23.4169458,11.0010161 L25.0126838,11.0010161 C25.5700349,11.0010161 26.0876645,10.6754255 26.3306846,10.1712448 C26.4464084,9.93229071 26.3366272,9.76558582 26.2243437,9.6676897 C25.988631,9.46268505 25.5391511,9.38950788 25.1454334,9.5879752 L25.0292605,9.65580455 L23.3231157,10.7977174 C23.2726559,10.7049298 23.2138557,10.6172855 23.1478271,10.5356185 L23.0435018,10.4177053 L24.7668488,9.26390731 C25.3955108,8.84354827 26.146152,8.97491047 26.5346088,9.31207346 Z M21.7943099,10.357654 C22.4927189,10.357654 23.0619551,10.9268902 23.0619551,11.6252993 C23.0619551,11.7761312 23.0352135,11.9209815 22.9864805,12.0553639 L22.9305929,12.1860908 L20.6583396,12.1860908 C20.574518,12.0168838 20.5269774,11.8267213 20.5266646,11.6252993 C20.5266646,10.9268902 21.0959008,10.357654 21.7943099,10.357654 Z M17.0555748,9.31207346 C17.4430933,8.97491047 18.1937344,8.84354827 18.8223964,9.26390731 L18.8223964,9.26390731 L20.5457434,10.4177053 C20.4365877,10.5306143 20.3418192,10.6582233 20.2661296,10.7977174 L20.2661296,10.7977174 L18.5602975,9.65580455 C18.3673202,9.52663172 18.1530747,9.47127193 17.952591,9.47127193 C17.7192667,9.47127193 17.5050212,9.54633605 17.365527,9.6676897 C17.2529309,9.76527305 17.1431496,9.93197794 17.2588734,10.1706193 C17.5031446,10.6747999 18.0207742,11.0007033 18.5781253,11.0007033 L18.5781253,11.0007033 L20.172925,11.0007033 C20.0978608,11.1946189 20.0562628,11.4051112 20.0562628,11.6252993 C20.0562628,11.8214043 20.0894161,12.0100029 20.1494674,12.1860908 L20.1494674,12.1860908 L16.3965744,12.1860908 C16.1460479,11.7106847 16.1279074,11.164906 16.3512232,10.6647914 L16.3512232,10.6647914 L16.7912865,9.67926209 C16.8432059,9.54477221 16.9314062,9.41997812 17.0555748,9.31207346 Z M14.2944664,13.6492155 L14.2944664,15.1989767 C14.2944664,15.664687 14.6172421,16.0562715 15.0504246,16.1622995 L20.9207512,16.1622995 L20.9207512,12.6571181 L15.286251,12.6571181 C14.7395341,12.6571181 14.2944664,13.1021858 14.2944664,13.6492155 Z M15.0507374,23.6971729 C15.0507374,24.4231055 15.6412417,25.0136098 16.3671743,25.0136098 L20.921064,25.0136098 L20.921064,16.6330141 L15.0507374,16.6330141 L15.0507374,23.6971729 Z M28.3029942,12.6571181 L22.6691196,12.6571181 L22.6691196,16.1619868 L28.5385079,16.1619868 C28.9720031,16.0559587 29.2944662,15.6643742 29.2944662,15.198664 L29.2944662,13.6489027 C29.2947788,13.1021858 28.8497112,12.6571181 28.3029942,12.6571181 L28.3029942,12.6571181 Z M22.6691196,25.0136098 L27.2220709,25.0136098 C27.9480035,25.0136098 28.5385079,24.4231055 28.5385079,23.6971729 L28.5385079,16.6330141 L22.6691196,16.6330141 L22.6691196,25.0136098 Z" id="Combined-Shape"></path></g></g></g></svg>
        <span>BONUS TALEP</span></a>
      </li>
      <!-- <li class="poker_router" v-if="is_poker"><router-link class="poker_router" to="/poker">Poker</router-link></li>  -->
      <!-- <li class="promotions_router"><router-link class="promotions_router" to="/promotions">Promosyonlar</router-link></li>
      <li class="affiliate_router"><router-link class="affiliate_router" to="/affiliate">Ortaklık</router-link></li> -->
      <!-- <li v-if="$auth() && !isMobile"><a href="https://bullbahisetkinlik.com/" target="_blank" data-title="BİLET AL"><span>BİLET AL</span></a></li>  -->
    </ul>
  </div>
</template>

<script>
import RequestPage from './Request.vue'
export default{
  data(){
    return{
              type: '',
              bonus_modal: false,
    }
  },
  components:{
    RequestPage
  },
  computed:{
    configSpesific(){ 
      return this.$store.getters['special/getConfigSpesific']
    },
    specialMenu(){
      return this.$store.getters['special/getMenu']
    },
    user(){
      return this.$user();
    },
    url(){
      let url = this.$store.getters['special/bonusUrl']
      if(this.$auth()){
        url = url + this.user.username;
      }
      return url
    },
    is_poker(){
      return this.$store.getters.getPokerStatus
    },
  }
}
</script>

<style lang="scss">
  li.other-g{
    position: relative;
    >a:hover{
        ul{
          display: flex !important;
        }
    }
    ul{
        position: absolute;
        display: none !important;
        z-index: 999;
        background: var(--client-header-menu);
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        top: 50px;
        left: 0px;
        width: auto !important;
      li{
        a{
          padding: 10px 20px !important;
        }
      }
    }
  }

</style>